document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(".hero-banner__title");
  
    headings.forEach((heading) => {
      const spans = heading.querySelectorAll("span");
  
      spans.forEach((span, index) => {
        // Preskačemo prva dva spana
        if (index < 2) return;
  
        const wrapper = document.createElement("div");
        wrapper.classList.add("hero-banner__char-wrapper");
        wrapper.style.position = "relative";
        span.style.position = "absolute";
  
        span.parentNode.insertBefore(wrapper, span);
        wrapper.appendChild(span);
      });
    });
  
    function updateWrapperSizes() {
      const wrappers = document.querySelectorAll(".hero-banner__char-wrapper");
  
      wrappers.forEach((wrapper) => {
        const span = wrapper.querySelector("span");
        const rect = span.getBoundingClientRect();
        wrapper.style.width = `${rect.width}px`;
        wrapper.style.height = `${rect.height}px`;
      });
    }
  
    requestAnimationFrame(updateWrapperSizes);
    window.addEventListener("resize", () => {
      requestAnimationFrame(updateWrapperSizes);
    });
  
    const observer = new ResizeObserver(updateWrapperSizes);
    document.querySelectorAll(".hero-banner__title").forEach((el) => {
      observer.observe(el);
    });
  });
  
  
  document.addEventListener("DOMContentLoaded", function () {
    const bgEl = document.querySelector(".js-hero-bg");
    if (!bgEl) return;
  
    const desktopBg = bgEl.dataset.bgDesktop;
    const phoneBg = bgEl.dataset.bgPhone;
  
    function setBg() {
      const isMobile = window.innerWidth <= 576;
      bgEl.style.backgroundImage = `url('${isMobile ? phoneBg : desktopBg}')`;
    }
  
    setBg();
    window.addEventListener("resize", setBg);
  });
  